import { makeStyles } from '@lifeomic/chroma-react/styles';
import * as React from 'react';
import clsx from 'clsx';
import { messages } from './IndicatorLegend';
import { useIntl } from 'react-intl';
import { Circle, Square, Triangle } from '@lifeomic/chromicons';

const useStyles = makeStyles(theme => ({
  root: {
    width: theme.pxToRem(12),
    height: theme.pxToRem(12),
    '& *': {
      strokeWidth: 0,
    },
  },
  impactRoot: {
    width: theme.pxToRem(8),
    height: theme.pxToRem(8),
  },
  impact: {
    '& *': {
      fill: theme.palette.red[300],
    },
  },
  variant: {
    '& *': {
      fill: theme.palette.green[500],
    },
  },
  gene: {
    '& *': {
      fill: theme.palette.purple[700],
    },
  },
}));

interface SpecificityIndicatorProps {
  className?: string;
  match?: 'gene' | 'variant' | 'impact';
  variant?: 'short' | 'copynumber' | 'structural' | 'expression';
}

export const SpecificityIndicator: React.FC<SpecificityIndicatorProps> = ({
  className,
  match = 'gene',
  variant = 'short',
  ...rootProps
}) => {
  const { formatMessage } = useIntl();
  const classes = useStyles({});

  if (variant === 'short') {
    return match === 'gene' ? (
      <Circle
        className={clsx(classes.root, classes.gene, className)}
        aria-label={formatMessage(messages.geneMatch)}
        {...rootProps}
      />
    ) : match === 'impact' ? (
      <Square
        className={clsx(classes.root, classes.impact, className)}
        aria-label={formatMessage(messages.impactMatch)}
        {...rootProps}
      />
    ) : match === 'variant' ? (
      <Triangle
        className={clsx(classes.root, classes.variant, className)}
        aria-label={formatMessage(messages.variantMatch)}
        {...rootProps}
      />
    ) : null;
  }

  return match === 'gene' ? (
    <Circle
      className={clsx(classes.root, classes.gene, className)}
      aria-label={formatMessage(messages.geneMatch)}
      {...rootProps}
    />
  ) : null;
};
